(ns journal-app-client.subs
  (:require [journal-app-client.components.modal :as m]
            [journal-app-client.utils.css :as css]
            [journal-app-client.utils.visibility :as visibility]
            [re-frame.core :as rf]
            [journal-app-client.notification :as notification]
            [journal-app-client.service-worker :as sw]
            [journal-app-client.routes :as routes]
            [journal-app-client.connection :as connection]
            [reagent.core :as r]))

(rf/reg-sub :get-db
  (fn [db _]
    db))

(rf/reg-sub :loading
  (fn [db _]
    (:loading db)))

(rf/reg-sub :query-map
  :<- [::routes/query-map]
  (fn [query-map [_ query-key]]
    (get-in query-map [query-key] query-map)))

(rf/reg-sub :connection-information
   (fn [_ [_ information-key]]
     (if information-key
       (get @connection/information information-key)
       @connection/information)))

(rf/reg-sub :notification-permission?
  (fn [_ _]
    (not (nil? @notification/permission))))

(rf/reg-sub :notification-persistent?
  (fn [_ _]
    (notification/persistent?)))

(rf/reg-sub :app-installable?
  (fn [_ _]
    (and @sw/deferred-prompt @sw/registration)))

(rf/reg-sub :service-worker-registered?
  (fn [_ _]
    (not (nil? @sw/registration))))

(rf/reg-sub :service-worker-messages
  (fn [_ _]
    @sw/messages))

(rf/reg-sub :get-in
  (fn [db [_ path]]
    (get-in db path)))

(defonce window-resize
  (let [a (r/atom {:width  (.-innerWidth  js/window)
                   :height (.-innerHeight js/window)})]
    (.addEventListener js/window "resize"
      (fn []
        (reset! a {:width  (.-innerWidth  js/window)
                   :height (.-innerHeight js/window)})))
    a))

(rf/reg-sub :window-size
  (fn [_ [_ dimension]]
    (if dimension
      (get @window-resize dimension)
      @window-resize)))

(defonce window-scroll
  (let [a (r/atom {:scroll-y (.-scrollY  js/window)
                   :scroll-x (.-scrollX js/window)})]
    (.addEventListener js/window "scroll"
      (fn []
        (swap! a (fn [a]
                   {:scroll-y (.-scrollY js/window)
                    :scroll-x (.-scrollX js/window)
                    :scroll-height (.-scrollHeight (.-body js/document))
                    :scroll-width (.-scrollWidth (.-body js/document))
                    :previous-scroll-y (:scroll-y a)
                    :previous-scroll-x (:scroll-x a)}))))
    a))

(rf/reg-sub :window-scroll
  (fn [_ [_ scroll-key]]
    (if scroll-key
      (get @window-scroll scroll-key)
      @window-scroll)))

(defonce CSS-supports
  {:scroll-margin-top (css/supports "scroll-margin-top:" "var(--scroll-margin-top)")})

(rf/reg-sub :CSS-supports
  (fn [_ [_ CSS-property]]
    (if CSS-property
      (get CSS-supports CSS-property)
      CSS-supports)))

(rf/reg-sub :theme
  (fn [_ [_ theme-key]]
    (case theme-key
      (:system :system-theme)
      @css/system-theme
      (:user-selected :user-selected-theme)
      @css/user-selected-theme
      (css/theme))))

(rf/reg-sub :display-mode
  (fn [_ [_ _]]
    @css/display-mode))

(rf/reg-sub :is-animating?
  (fn [_ [_ id]]
    (if id
      (get @css/animation-variables id)
      (not (empty? @css/animation-variables)))))

(rf/reg-sub :app-hidden?
  (fn [_ [_ _]]
    @visibility/hidden?))

(rf/reg-sub :modal
  (fn [_ [_ id]]
    (if id
      (get @m/variables id)
      @m/variables)))

(rf/reg-sub :state-change-synced?
  (fn [db [_ {:keys [db-updates shared-state-path]}]]
    (reduce-kv
      (fn [r path v]
        (and r (= (get-in db (into shared-state-path path)) v)))
      false
      db-updates)))